import { submitForm } from '@rategravity/frontend/modules/hubspot';
import { sessionStorage } from '@rategravity/frontend/modules/storage';
import { getAuthToken } from './authenticate';
import parseName from './parse-name';

const getLeadPayload = (email, { name, ...props }) => {
  const { borrower } = JSON.parse(sessionStorage.getItem('session-model'));
  const payload = {
    email: email || borrower.email,
    ...props
  };
  if (name || borrower.name) {
    const { first, last } = parseName(name || borrower.name);
    payload.firstname = first;
    payload.lastname = last;
  }

  return payload;
};

/**
 * Submits various hubspot forms used for lead capturing.
 * See Hubspot > Marketing > Lead Capture > Forms dashboard to modify
 *   and change capture forms.
 */
export default {
  registerOutOfStateLead: (email, props) => {
    const payload = getLeadPayload(email, props);

    // "Out Of State Interest"
    submitForm('17bf71f3-08d3-48b6-acea-a05dc0f8615f', payload);
  },
  identifyContact: (email) => {
    const { borrower } = JSON.parse(sessionStorage.getItem('session-model'));
    const payload = {
      email: email || borrower.email,
      // eslint-disable-next-line @typescript-eslint/camelcase
      user_id: getAuthToken()
    };

    // "Dashboard Completion"
    submitForm('b237b9ee-5c31-4152-bd97-4f7cd51186b2', payload);
  },
  registerLowLoanAmountLead: (email, props) => {
    const payload = getLeadPayload(email, props);

    // "Low Loan Amount Interest"
    submitForm('1859be68-16f3-4057-ab62-1918440477d5', payload);
  },
  registerManufacturedMobileLead: (email, props) => {
    const payload = getLeadPayload(email, props);

    // "Manufactured/Mobile Interest"
    submitForm('7ee1f800-2988-44d0-8f82-486a4a90feb4', payload);
  },
  registerExpiringVisaLead: (email, props) => {
    const payload = getLeadPayload(email, props);

    // "Expiring Visa Interest"
    submitForm('45cb82b7-fce3-4007-bab0-baba4dff6267', payload);
  }
};



// WEBPACK FOOTER //
// ./src/modules/hubspot.js